import logo from './logo.svg';
import './App.css';
import RecordSearchApp from './RecordSearchApp';

function App() {
  return (
    <div className="App">
      <RecordSearchApp />
    </div>
  );
}

export default App;
